<div class="tw-mx-3 tw-my-5 tw-flex tw-justify-between">
  <ate-button-control class="tw-w-fit tw-min-w-0 tw-p-3" (click)="navigateBack()" color="secondary"
    ><ate-icon name="chevron-left-v2"></ate-icon>
    <span class="tw-hidden md:tw-block">Back</span>
  </ate-button-control>
  <ate-button-control
    class="tw-w-fit tw-min-w-0 tw-cursor-pointer tw-p-3"
    (click)="setArchiveStatus($event, !customer?.isArchived)"
    color="secondary">
    @if (isSetArchiveLoading) {
      <ate-icon class="tw-size-5 tw-shrink-0 tw-animate-spin tw-text-white md:tw-mr-2" name="loading-spinner-gradient-v3"></ate-icon>
    } @else {
      <ate-icon class="tw-size-5 tw-shrink-0 md:tw-mr-2" [name]="customer?.isArchived ? 'unarchive' : 'archive-v3'"></ate-icon>
    }
    <span class="tw-hidden md:tw-block">{{ customer?.isArchived ? 'Unarchive' : 'Archive' }}</span>
  </ate-button-control>
</div>
<div class="tw-mx-3 tw-mt-5 tw-flex tw-gap-5">
  <h2 class="tw-flex-2 tw-flex-1 tw-text-3xl group-focus-within:tw-hidden md:tw-block md:group-focus-within:tw-block">{{ customer | fullname }}</h2>
</div>
<div class="tw-group tw-mx-3 tw-my-3 tw-flex tw-items-center tw-gap-3">
  <div class="tw-ml-auto tw-flex tw-flex-1 tw-items-center tw-justify-start tw-gap-3">
    <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-3">
      @if (statusConfig) {
        <span
          [ngClass]="statusConfig?.classes"
          class="tw-block tw-max-w-full tw-truncate tw-break-all tw-rounded-2xl tw-p-1 tw-px-2 tw-text-sm tw-font-semibold">
          {{ statusConfig?.name }}
        </span>
      }
    </div>
    @if (customer?.isArchived) {
      <div class="tw-flex tw-shrink-0 tw-items-center tw-gap-3">
        @if (customer) {
          <span class="tw-block tw-max-w-full tw-truncate tw-break-all tw-rounded-2xl tw-bg-white tw-p-1 tw-px-2 tw-text-sm tw-font-semibold">
            Archived
          </span>
        }
      </div>
    }
  </div>
</div>
<div
  class="tw-mb-5 tw-block tw-overflow-hidden tw-border-b tw-border-l-0 tw-border-r-0 tw-border-t tw-border-solid tw-border-slate-200 tw-bg-white md:tw-mx-3 md:tw-mx-[10px] md:tw-rounded-[5px] md:tw-border-l md:tw-border-r">
  <div
    class="tw-mb-5 tw-flex tw-w-auto tw-items-center tw-justify-between tw-border-0 tw-border-b tw-border-solid tw-border-slate-300 tw-px-5 tw-pb-5 tw-pt-5">
    <h3 class="tw-flex tw-max-w-full tw-items-center tw-gap-3 tw-truncate tw-break-all tw-text-2xl tw-font-bold tw-text-slate-800 lg:tw-text-xl">
      <ate-icon class="tw-shrink-0" name="profile-v2"></ate-icon>{{ customer | fullname }}
    </h3>
    <ate-button-control
      class="tw-w-fit tw-min-w-[48px] tw-p-3 md:tw-flex md:tw-gap-3"
      [routerLink]="['../../edit/' + customerUuid]"
      [queryParams]="{ fromCustomerProfile: true }"
      color="cta">
      <ate-icon class="tw-h-4 tw-w-4" name="edit-v3"></ate-icon>
      <span class="tw-hidden md:tw-block">Edit Customer Details</span>
    </ate-button-control>
  </div>
  <section class="tw-grid tw-px-5 tw-pb-5 md:tw-grid-cols-2">
    @if (customer?.email) {
      <div class="tw-flex tw-items-start tw-gap-3">
        <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="email-v3"></ate-icon>
        <div>
          <h4 class="tw-mb-1 tw-text-base tw-font-bold">Email</h4>
          <p class="tw-mb-0 tw-break-all">{{ customer.email }}</p>
          @if (isGmailConnected) {
            <a (click)="composeEmail()" class="tw-mb-5 tw-block tw-w-fit tw-cursor-pointer tw-text-brand-maroon">Send Email</a>
          } @else {
            <a [href]="'mailto:' + customer.email" class="tw-mb-5 tw-block tw-w-fit tw-text-brand-maroon">Send Email</a>
          }
        </div>
      </div>
    }
    @if (customer?.mobileNumber) {
      <div class="tw-flex tw-items-start tw-gap-3">
        <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="phone-v2"></ate-icon>
        <div>
          <h4 class="tw-mb-1 tw-text-base tw-font-bold">Mobile Number</h4>
          <p class="tw-break-all">{{ customer.mobileNumber }}</p>
        </div>
      </div>
    }
    @if (customer?.landlineNumber) {
      <div class="tw-flex tw-items-start tw-gap-3">
        <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="phone-v2"></ate-icon>
        <div>
          <h4 class="tw-mb-1 tw-text-base tw-font-bold">Landline Number</h4>
          <p class="tw-break-all">{{ customer.landlineNumber }}</p>
        </div>
      </div>
    }
    @if (customer?.companyName) {
      <div class="tw-flex tw-items-start tw-gap-3">
        <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="building"></ate-icon>
        <div>
          <h4 class="tw-mb-1 tw-text-base tw-font-bold">Company Name</h4>
          <p class="tw-break-all">{{ customer.companyName }}</p>
        </div>
      </div>
    }
    @if (customer?.acquisition) {
      <div class="tw-flex tw-items-start tw-gap-3">
        <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="filter"></ate-icon>
        <div>
          <h4 class="tw-mb-1 tw-text-base tw-font-bold">Acquisition Method</h4>
          <p class="tw-break-all">{{ acquisitionLabel | titlecase }}</p>
        </div>
      </div>
    }
    @if (customer?.type) {
      <div class="tw-flex tw-items-start tw-gap-3">
        <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="tag-v2"></ate-icon>
        <div>
          <h4 class="tw-mb-1 tw-text-base tw-font-bold">Customer Type</h4>
          <p class="tw-break-all">{{ customer.type }}</p>
        </div>
      </div>
    }
    @if (formattedAddress) {
      <div class="tw-flex tw-items-start tw-gap-3">
        <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="location-pin-v2"></ate-icon>
        <div>
          <h4 class="tw-mb-1 tw-text-base tw-font-bold">Address</h4>
          <p class="tw-whitespace-pre-line tw-break-all">{{ formattedAddress }}</p>
        </div>
      </div>
    }
    @if (customer?.repeat != null) {
      <div class="tw-flex tw-items-start tw-gap-3">
        <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="user-switch"></ate-icon>
        <div>
          <h4 class="tw-mb-1 tw-text-base tw-font-bold">Repeat Customer</h4>
          <p class="tw-break-all">{{ customer.repeat === 1 ? 'Repeat' : 'One-off' }}</p>
        </div>
      </div>
    }
    <div class="tw-flex tw-items-start tw-gap-3">
      <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="send-mail"></ate-icon>
      <div>
        <h4 class="tw-mb-1 tw-text-base tw-font-bold">Marketing Opt-in</h4>
        <p class="tw-break-all">{{ customer?.marketing ? 'Yes' : 'No' }}</p>
      </div>
    </div>
    <div class="tw-flex tw-items-start tw-gap-3 md:tw-col-span-2">
      <ate-icon class="tw-mt-0.5 tw-size-5 tw-shrink-0" name="document-text"></ate-icon>
      <div>
        <h4 class="tw-mb-1 tw-text-base tw-font-bold">Notes</h4>
        <p class="tw-break-all" [innerHTML]="htmlContent"></p>
      </div>
    </div>
  </section>
</div>

<div class="tw-block md:tw-mx-3">
  <enquiries-list-component class="tw-overflow-hidden tw-rounded-b-lg" [params]="{ customerUuid }">
    <div
      class="tw-flex tw-w-auto tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-overflow-hidden tw-rounded-t-lg tw-border-0 tw-border-b tw-border-solid tw-border-slate-300 tw-bg-white tw-px-5 tw-pb-5 tw-pt-5">
      <h3 class="tw-max-w-full tw-truncate tw-break-all tw-text-2xl tw-font-bold tw-text-slate-800 lg:tw-text-xl">Customer Enquiries</h3>
      <ate-button-control
        class="tw-w-fit tw-min-w-[48px] tw-shrink-0 tw-gap-3 tw-p-3 md:tw-flex"
        [routerLink]="['../../../enquiries/add/' + customerUuid]"
        [queryParams]="{ fromCustomerProfile: true }"
        color="cta">
        <ate-icon class="tw-h-4 tw-w-4 tw-shrink-0" name="plus-v3"></ate-icon>
        <span class="tw-flex"
          >New Enquiry<span class="tw-hidden md:tw-block">&nbsp;for {{ customer | fullname }}</span></span
        >
      </ate-button-control>
    </div>
  </enquiries-list-component>
</div>
